module.exports = __webpack_public_path__ + "img/avator.88ddc89f.jpg";